export default __webpack_public_path__ + "static/media/HistoricUnlinkedTask.e23548ef.svg";